import { getData, postData, putData, deleteData } from './http.service';
import {
  ApiCallFailedAction,
  ApiCallInProgress,
  ApiCallSuccessAction,
} from '../store/actions/uistate.action';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
export function getAllSubjects() {
  const allSubjectsUrl = '/file-explorer-service/api/v2/subjects';

  return getData(allSubjectsUrl)
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      throw error;
    });
}
export function getSubjectById(id, dispatch) {
  const subjectByIdUrl = `/file-explorer-service/api/v2/subjects/${id}`;
  dispatch(ApiCallInProgress());
  return getData(subjectByIdUrl)
    .then(response => {
      dispatch(ApiCallSuccessAction(handleApiSuccess(response.data, {})));
      return response.data.data;
    })
    .catch(error => {
      dispatch(ApiCallFailedAction(handleApiError(error, {})));
      throw error;
    });
}

export function getVideos(body) {
  return dispatch => {
    const videosUrl = '/file-explorer-service/api/v2/videos';
    dispatch(ApiCallInProgress());
    return postData(videosUrl, body)
      .then(response => {
        dispatch(ApiCallSuccessAction(handleApiSuccess(response.data, {})));
        return response.data.data;
      })
      .catch(error => {
        dispatch(ApiCallFailedAction(handleApiError(error, {})));
        throw error;
      });
  };
}

export function uploadFiles(body) {
  const uploadUrl = '/file-explorer-service/api/v2/files/upload';
  // const UserInfo = `{"userId":"a48eafde-3a40-4977-98ab-6c0a94c0ccd7","email":"sinduja@frostinteractive.com","mobile":"9182606354","userName":"sinduja p1","image":"https://d1k3nlqshgkoey.cloudfront.net/4e4a35e3-b8e0-4505-86a8-c77904de8e8a.png","roles":[{"roleId":"c8b4e2d4-dbf5-4703-a40c-4fe20215b6b6","roleName":"CONTENT_UPLOADER"},{"roleId":"782f842e-b10f-46d8-bedb-273f610b483e","roleName":"CONTENT_ADMIN"},{"roleId":"5374c7c0-4990-43c0-9a42-53953ffb411f","roleName":"SUPER_ADMI"},{"roleId":"06fe6b07-1879-4125-9939-998956f45875","roleName":"USER_MANAGER"},{"roleId":"93ea1dd1-d891-4aec-b0c3-095b7a201036","roleName":"CONTENT_DEVELOPER"}],"userProfile":{"userProfileId":"90aee43c-d649-4743-bc5b-68ddf7cdfb47","userId":"a48eafde-3a40-4977-98ab-6c0a94c0ccd7","firstName":"sinduja","lastName":"p1","mobile":"9849497450","email":"sinduja@frostinteractive.com","image":"https://d1k3nlqshgkoey.cloudfront.net/4e4a35e3-b8e0-4505-86a8-c77904de8e8a.png","theme":"DARK","search":true,"gender":"MALE"}}userinfo: {"userId":"a48eafde-3a40-4977-98ab-6c0a94c0ccd7","email":"sinduja@frostinteractive.com","mobile":"9182606354","userName":"sinduja p1","image":"https://d1k3nlqshgkoey.cloudfront.net/4e4a35e3-b8e0-4505-86a8-c77904de8e8a.png","roles":[{"roleId":"c8b4e2d4-dbf5-4703-a40c-4fe20215b6b6","roleName":"CONTENT_UPLOADER"},{"roleId":"782f842e-b10f-46d8-bedb-273f610b483e","roleName":"CONTENT_ADMIN"},{"roleId":"5374c7c0-4990-43c0-9a42-53953ffb411f","roleName":"SUPER_ADMI"},{"roleId":"06fe6b07-1879-4125-9939-998956f45875","roleName":"USER_MANAGER"},{"roleId":"93ea1dd1-d891-4aec-b0c3-095b7a201036","roleName":"CONTENT_DEVELOPER"}],"userProfile":{"userProfileId":"90aee43c-d649-4743-bc5b-68ddf7cdfb47","userId":"a48eafde-3a40-4977-98ab-6c0a94c0ccd7","firstName":"sinduja","lastName":"p1","mobile":"9849497450","email":"sinduja@frostinteractive.com","image":"https://d1k3nlqshgkoey.cloudfront.net/4e4a35e3-b8e0-4505-86a8-c77904de8e8a.png","theme":"DARK","search":true,"gender":"MALE"}}`;

  return putData(uploadUrl, body)
    .then(response => response.data?.data)
    .catch(error => {
      throw error;
    });
}

export function copyFiles(body) {
  const copyUrl = '/file-explorer-service/api/v2/files/copy';

  return putData(copyUrl, body)
    .then(response => response.data?.data)
    .catch(error => {
      throw error;
    });
}

export function moveFiles(body) {
  const moveUrl = '/file-explorer-service/api/v2/files/move';

  return putData(moveUrl, body)
    .then(response => response.data?.data)
    .catch(error => {
      throw error;
    });
}
export function deleteFiles(body, dispatch) {
  const deleteUrl = '/file-explorer-service/api/v2/files/delete';
  dispatch(ApiCallInProgress());
  return deleteData(deleteUrl, body)
    .then(response => {
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, {})));
      return response.data;
    })
    .catch(error => {
      dispatch(ApiCallFailedAction(handleApiError(error, {})));
      throw error;
    });
}

export function getPreviewVideosCatalogue(videoType) {
  const url = '/file-explorer-service/api/v2/preview-videos';
  const previewVideosCatalogue = videoType ? `${url}?type=${videoType}` : url;

  return getData(previewVideosCatalogue)
    .then(response => response.data.data)
    .catch(error => {
      throw error;
    });
}

export function getPreviewVideosList(id) {
  const previewVideosList = `/file-explorer-service/api/v2/preview-videos/${id}`;
  return getData(previewVideosList)
    .then(response => response.data.data)
    .catch(error => {
      throw error;
    });
}

export function createCatalogue(body) {
  const createCatalogueFolder = '/file-explorer-service/api/v2/preview-videos';

  return postData(createCatalogueFolder, body)
    .then(response => response.data.data)
    .catch(error => {
      throw error;
    });
}

export function uploadPreviewFiles(body) {
  const uploadPreviewVideosUrl = '/file-explorer-service/api/v2/preview-videos';

  return putData(uploadPreviewVideosUrl, body)
    .then(response => response.data.data)
    .catch(error => {
      throw error;
    });
}

export function deletePreviewVideos(body) {
  const deletePreviewVideosUrl = '/file-explorer-service/api/v2/preview-videos';

  return deleteData(deletePreviewVideosUrl, body)
    .then(response => response.data.data)
    .catch(error => {
      throw error;
    });
}
